
const settleIn = {
  path: 'settleIn',
  component: resolve => require(['../../../../../pages/modules/enterprise/settleIn'], resolve),
}

export default settleIn
